'use client';

import { type BaseFormBuilderProps, useBaseFormBuilder } from '@capsicum/common';
import { type PropsWithChildren, useMemo } from 'react';

import { Button } from '../atoms';

import componentMapping from './componentMapping';

export type FormBuilderProps = Omit<BaseFormBuilderProps, 'componentMapping' | 'submitButton'> & {};

const useFormBuilder = (props: FormBuilderProps) => {
	const baseFormBuilder = useBaseFormBuilder({
		...props,
		componentMapping,
		submitButton: {
			component: Button,
			label: 'submit',
			props: {},
			submitEvent: 'onClick'
		}
	});

	const FormProviderWrapper = ({ children }: PropsWithChildren) => {
		if (props.handleSubmit) {
			return <form onSubmit={baseFormBuilder.form.handleSubmit(props.handleSubmit)}>{children}</form>;
		}

		return children;
	};

	const FormComponent = useMemo(() => {
		const comp = ({ children }: PropsWithChildren) => (
			<FormProviderWrapper>
				<baseFormBuilder.BaseFormComponent>{children}</baseFormBuilder.BaseFormComponent>
			</FormProviderWrapper>
		);

		return comp;
	}, []);

	return { ...baseFormBuilder, FormComponent, FormProviderWrapper };
};

export { useFormBuilder };
